import BaseService from './Base';
import ConfigService from './Config';

class TranslationService extends BaseService {
  static endpoint = 'api/2.0/translate/';

  static async getTranslations(data) {
    const url = ConfigService.generateURL(this.endpoint);
    try {
      const response = await window.fetch(url, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          Accept: 'application/json, text/plain, */*',
          Authorization: 'jwt ' + localStorage.getItem('jwt_token'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Time-Zone': jstz.determine().name()
        }
      });
      const JSONresponse = await response.json();
      if (response.ok) {
        return JSONresponse;
      } else {
        return null;
      }
    } catch (e) {
      return null;
    }
  }
}

export default TranslationService;